export default __webpack_public_path__ + "ab2d989efbfd6723adb9769bdeb8ba07.png";